module.exports = __webpack_public_path__ + "static/media/headerLogo.5613e45b.png";